module.exports = __webpack_public_path__ + "static/assets/3f5f9ee68abb9741dedefb8b5be40aa1.svg";